import React from "react";
import { useSelector } from "react-redux";

import { ConfigureDestinationsModal } from "../../modals/ConfigureDestinationsModal";
import { DestinationConfigRow } from "../shared/ConfigPageRow";
import useFirstDestinationOfType from "../../../hooks/useFirstDestinationOfType";

const InstructionModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig = {},
}) => {
  const stackAdapt = useFirstDestinationOfType("stackadapt") || {
    settings: {},
  };
  const { settings: allSettings } = stackAdapt;

  return (
    <ConfigureDestinationsModal
      limitSettings={[]}
      open={open}
      includeHeader={true}
      settings={allSettings}
      dest={destination}
      onClose={onClose}
      onSave={handleUpdateConfigureDest}
      existingConfig={existingConfig}
    />
  );
};

const InstructionRow = ({ setConfigModalOpen }) => {
  return (
    <DestinationConfigRow
      name="Configuration"
      labelText="Instructions"
      onOpenConfigModal={() => setConfigModalOpen("credentials")}
    />
  );
};

const INSTRUCTION = "INSTRUCTION";

const Rows = {
  INSTRUCTION: InstructionRow,
};

const Modals = {
  INSTRUCTION: InstructionModal,
};

const RowOrder = [INSTRUCTION];

export default {
  Rows,
  RowOrder,
  Modals,
};
